import React, { useEffect, useState } from "react";
import Profile from "./Profile";
import Expense from "./Expense";
import NewEntry from "./NewEntry";
import OldEntries from "./OldEntries";
import CreateProfile from "./CreateProfile";

const Dashboard = () => {

    const getValFromHash = () => {
        const hash = window.location.hash;

        if (hash === "#profile") return 1;
        if (hash === "#create_user") return 2;
        if (hash === "#expense") return 3;
        if (hash === "#new_entry") return 4;
        if (hash === "#old_entries") return 5;

        return 1;
    };

    const [val, setVal] = useState(getValFromHash());

    // ✅ Update on mount + refresh
    useEffect(() => {
        // const currentVal = getValFromHash();
        // setVal(currentVal);
        // console.log(val);
        // default hash fix
        if (!window.location.hash) {
            window.location.hash = "profile";
        }
    }, []);

    const navigate = (hash) => {
        window.location.href = `/dashboard#${hash}`;
        const currentVal = getValFromHash();
        setVal(currentVal);
        // console.log(val);
    };

    return (
        <div style={{ minHeight: "550px", background: "#f5f5f5" }}>
            <div className="row" style={{minHeight:'100vh'}}>

                {/* SIDEBAR */}
                <div className="col-md-2 bg-dark text-white p-2 border border-danger">

                    <button
                        className={`btn w-100 rounded-0 mb-2 ${val === 1 ? "btn-primary" : "btn-light"}`}
                        onClick={() => navigate("profile")}
                    >
                        Profile
                    </button>
                    <button
                        className={`btn w-100 rounded-0 mb-2 ${val === 2 ? "btn-primary" : "btn-light"}`}
                        onClick={() => navigate("create_user")}
                    >
                        Create User
                    </button>

                    <button
                        className={`btn w-100 rounded-0  mb-2 ${val === 3 ? "btn-primary" : "btn-light"}`}
                        onClick={() => navigate("expense")}
                    >
                        Expense
                    </button>

                    <button
                        className={`btn w-100 rounded-0  mb-2 ${val === 4 ? "btn-primary" : "btn-light"}`}
                        onClick={() => navigate("new_entry")}
                    >
                        New Entry
                    </button>

                    <button
                        className={`btn w-100 rounded-0  mb-2 ${val === 5 ? "btn-primary" : "btn-light"}`}
                        onClick={() => navigate("old_entries")}
                    >
                        Old Entries
                    </button>

                </div>

                {/* CONTENT AREA */}
                <div className="col-md-10 p-3">

                    {val === 1 && <Profile />}
                    {val === 2 && <CreateProfile />}
                    {val === 3 && <Expense />}
                    {val === 4 && <NewEntry />}
                    {val === 5 && <OldEntries />}

                </div>

            </div>
        </div>
    );
};

export default Dashboard;